module.exports = __webpack_public_path__ + "img/phone.07477130.png";